import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const Twentyfifththeme = ({get_data}) => {
    const navigate = useNavigate();
    const [cartCount, setCartCount] = useState(0);
    const [visibleCategories, setVisibleCategories] = useState(12);

    React.useEffect(() => {
        const updateCount = () => {
            const storedCart = localStorage.getItem('cart');
            const cartItems = storedCart ? JSON.parse(storedCart) : [];
            const count = cartItems.reduce((acc, item) => acc + (item.quantity || 1), 0);
            setCartCount(count);
        };

        updateCount();
        window.addEventListener('storage', updateCount);
        window.addEventListener('cartUpdated', updateCount);

        return () => {
            window.removeEventListener('storage', updateCount);
            window.removeEventListener('cartUpdated', updateCount);
        };
    }, []);

    const [cart, setCart] = useState([]);

        const addToCart = (service) => {
        const storedCart = localStorage.getItem('cart');
        let cartItems = storedCart ? JSON.parse(storedCart) : [];
        
        // Check if item already exists
        const existingItemIndex = cartItems.findIndex(item => 
            (item.id && service.id && item.id === service.id) || 
            (item.service_name && service.service_name && item.service_name === service.service_name)
        );
        
        if (existingItemIndex > -1) {
            cartItems[existingItemIndex].quantity = (cartItems[existingItemIndex].quantity || 1) + 1;
        } else {
            cartItems.push({ ...service, quantity: 1 });
        }

        localStorage.setItem('cart', JSON.stringify(cartItems));
        window.dispatchEvent(new Event('cartUpdated'));
        // alert(`Added ${service.service_name} to cart`);
        navigate('/cart');
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Coffee House */
            --coffee-dark: #3f2e3e;
            --coffee-med: #a0522d;
            --latte: #f5deb3;
            --cream: #fff8dc;
            --text-dark: #2c1810;
        }

        body { font-family: 'Merriweather', serif; background: var(--cream); color: var(--text-dark); margin: 0; }
        .container { max-width: 1000px; margin: 0 auto; padding: 0 30px; }
        
        .navbar { background: var(--coffee-dark); padding: 15px 0; color: var(--latte); }
        .nav-inner { display: flex; justify-content: space-between; align-items: center; }
        .brand { font-size: 1.8rem; font-weight: 900; letter-spacing: 1px; }
        .nav-links a { color: var(--latte); margin-left: 20px; text-decoration: none; font-size: 0.9rem; text-transform: uppercase; }
        
        .hero { text-align: center; padding: 100px 0; background: url('https://images.unsplash.com/photo-1497935586351-b67a49e012bf?ixlib=rb-1.2.1&auto=format&fit=crop&w=1500&q=80') center/cover; color: white; position: relative; }
        .hero::before { content: ''; position: absolute; inset: 0; background: rgba(44, 24, 16, 0.7); }
        .hero-content { position: relative; z-index: 1; }
        .hero h1 { font-size: 3.5rem; margin-bottom: 20px; font-style: italic; }
        
        .btn { background: var(--coffee-med); color: white; border: none; padding: 12px 30px; font-family: 'Merriweather', serif; font-size: 1rem; cursor: pointer; border-radius: 4px; transition: 0.3s; }
        .btn:hover { background: var(--coffee-dark); }
        
        .section-title { text-align: center; margin: 80px 0 50px; font-size: 2.5rem; position: relative; display: inline-block; width: 100%; }
        .section-title::after { content: '☕'; display: block; font-size: 1.5rem; margin-top: 10px; }
        
        .menu-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(400px, 1fr)); gap: 40px; }
        .menu-item { display: flex; align-items: flex-start; gap: 20px; background: white; padding: 20px; border-radius: 8px; box-shadow: 0 4px 10px rgba(0,0,0,0.05); }
        .menu-icon { font-size: 2rem; color: var(--coffee-med); }
        
        .product-grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(280px, 1fr)); gap: 30px; }
        .product-card { background: white; border-radius: 8px; overflow: hidden; box-shadow: 0 4px 10px rgba(0,0,0,0.05); }
        .product-img { height: 200px; width: 100%; object-fit: cover; }
        
        .footer { background: var(--coffee-dark); color: var(--latte); padding: 50px 0; text-align: center; margin-top: 100px; }
            `}</style>
            
            <link href="https://fonts.googleapis.com/css2?family=Merriweather:ital,wght@0,300;0,700;0,900;1,400&display=swap" rel="stylesheet" />

            <nav className="navbar">
                <div className="container nav-inner">
                    <div className="brand">{get_data.service_name}</div>
                    <div className="nav-links">
                        <a href="#">Home</a>
                        <a href="#menu">Menu</a>
                        <a href="#store">Store</a>
                        <a href="#contact">Contact</a>
                        <a href="/cart" style={{display: 'flex', alignItems: 'center', position: 'relative', marginLeft: '15px', color: 'inherit', textDecoration: 'none'}}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                <circle cx="9" cy="21" r="1"></circle>
                                <circle cx="20" cy="21" r="1"></circle>
                                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                            </svg>
                            {cartCount > 0 && (
                                <span style={{
                                    position: 'absolute',
                                    top: '-8px',
                                    right: '-10px',
                                    background: 'red',
                                    color: 'white',
                                    borderRadius: '50%',
                                    width: '20px',
                                    height: '20px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '0.7rem',
                                    fontWeight: 'bold'
                                }}>
                                    {cartCount}
                                </span>
                            )}
                        </a>
                    </div>
                </div>
            </nav>

            <div className="hero">
                <div className="container hero-content">
                    <h1>Warmth in Every Detail</h1>
                    <p style={{fontSize: '1.2rem', marginBottom: '40px', fontStyle: 'italic'}}>Cozy vibes, premium quality, and exceptional service.</p>
                    <a href="#menu" className="btn">Explore Menu</a>
                </div>
            </div>

            <div className="container">
                <div className="section-title" id="menu">Our Offerings</div>
                <div className="menu-grid">
                    {get_data.all_categories && get_data.all_categories.slice(0, visibleCategories).map((item, index) => (
                        <div className="menu-item" key={index}>
                            <div className="menu-icon">
                                 {item.icon ? <img src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} style={{width: '60px', height: '60px', borderRadius: '50%', objectFit: 'cover'}} alt=""/> : <span>☕</span>}
                            </div>
                            <div>
                                <h3 style={{margin: '0 0 10px', fontSize: '1.2rem'}}>{item.name}</h3>
                                <p style={{margin: '0 0 10px', fontSize: '0.9rem', lineHeight: 1.6, color: '#666'}}>{item.description}</p>
                                <div style={{display: 'flex', gap: '15px'}}>
                                    <a href={`tel:${get_data.mobile}`} style={{color: 'var(--coffee-med)', fontWeight: 'bold', fontSize: '0.8rem', border: '1px solid var(--coffee-med)', padding: '5px 10px', borderRadius: '4px'}}>Call</a>
                                    <a href="#contact" style={{color: 'var(--text-dark)', fontWeight: 'bold', fontSize: '0.8rem', border: '1px solid var(--text-dark)', padding: '5px 10px', borderRadius: '4px'}}>Enquire</a>
                                </div>
                            </div>
                        </div>
                    )) }
                    { get_data.all_categories && visibleCategories < get_data.all_categories.length && (
                        <div style={{textAlign: 'center', marginTop: '40px'}}>
                            <button 
                                onClick={() => setVisibleCategories(prev => prev + 6)} 
                                className="btn"
                            >
                                Show More
                            </button>
                        </div>
                    )}
                </div>
                
                <div className="section-title" id="store">Goods</div>
                <div className="product-grid">
                     {get_data.product_services && get_data.product_services.map((item, index) => (
                        <div className="product-card" key={index}>
                             {item.featured_image ? (<img src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} className="product-img" alt={item.service_name}/>) : (<div className="product-img" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f0f0f0', fontSize: '1.5rem', fontWeight: 'bold', color: '#555',  }}>{(item.service_name || 'PR').slice(0, 2).toUpperCase()}</div>)}
                             <div style={{padding: '20px'}}>
                                 <h3>{item.service_name}</h3>
                                 {item.price && <div style={{fontWeight: 900, fontSize: '1.1rem', color: 'var(--coffee-med)', margin: '10px 0'}}>₹{item.price}</div>}
                                 <button onClick={() => addToCart(item)} className="btn" style={{width: '100%', fontSize: '0.9rem'}}>Add to Order</button>
                             </div>
                        </div>
                     ))}
                </div>
            </div>

            <footer className="footer" id="contact">
                <div className="container">
                    <h3>{get_data.service_name}</h3>
                    <p>{get_data.business_location_name}</p>
                    <p>{get_data.email}</p>
                </div>
            </footer>
        </>
    );
};

export default Twentyfifththeme;
